export default __webpack_public_path__ + "static/media/homepage-banner3.a1940a14.png";